import Transforms from './transforms'

const endpoints = {
    list: {
        path: '/templates',
        transform: Transforms.list,
    },
    download: {
        path: '/templates/:entityKey/:format',
        transform: Transforms.download,
    },
}

export default {
    name: 'templates',
    endpoints,
}
